import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { editFormDataAF, IRideDto, RideCrudModeKeyTuple } from "@ryde/shared";

import { RideBottomBlockStyled } from "../ride.styled";
import { RideTabsBottomSiteItem } from "./parts/ride-tabs-bottom-site-item";
import { RIDE_BOTTOM_SITES_LIST_DELIMITER } from "./ride-tabs-bottom-sites.constants";
import {
  buildRideBottomSiteDisplayItems,
  collectRideBottomSiteIds,
} from "./ride-tabs-bottom-sites.utils";
import { useRideBottomSiteLabels } from "./use-ride-bottom-site-labels";

export const RideTabsBottomSites: FC = () => {
  const { t } = useTranslation();
  const rideDto = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );

  const siteIds = useMemo(() => collectRideBottomSiteIds(rideDto), [rideDto]);
  const siteIdsKey = useMemo(
    () =>
      siteIds
        .slice()
        .sort((a, b) => a - b)
        .join(","),
    [siteIds],
  );

  const siteLabelsById = useRideBottomSiteLabels(siteIdsKey);

  const siteItems = useMemo(
    () => buildRideBottomSiteDisplayItems({ rideDto, siteLabelsById }),
    [rideDto, siteLabelsById],
  );

  if (!siteItems.length) {
    return null;
  }

  return (
    <RideBottomBlockStyled className="ride-bottom-sites-block">
      <label>{t("ride.SITES")}:</label>
      <span>
        {siteItems.map((item, index) => (
          <span key={item.key}>
            <RideTabsBottomSiteItem item={item} />
            {index < siteItems.length - 1 && RIDE_BOTTOM_SITES_LIST_DELIMITER}
          </span>
        ))}
      </span>
    </RideBottomBlockStyled>
  );
};
